import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const SendOutlineIcon = (props: IconProps) => (
  <Icon width="22px" height="22px" viewBox="0 0 22 22" {...props}>
    <path d="M3.45341 5.69285L10.129 8.55507L3.44453 7.66618L3.45341 5.69285ZM10.1201 13.444L3.44453 16.3062V14.3328L10.1201 13.444ZM1.67564 2.99951L1.66675 9.22173L15.0001 10.9995L1.66675 12.7773L1.67564 18.9995L20.3334 10.9995L1.67564 2.99951Z" />
  </Icon>
);

export default memo(SendOutlineIcon);
